module.exports = __webpack_public_path__ + "static/media/Gurdurr_gaussian2.53001914.png";